import { onMounted, ref, getCurrentInstance } from 'vue'

export default function () {
  const openStatus = ref([])
  const typeOptions = ref([])
  const statusOptions = ref([])

  const { proxy } = getCurrentInstance()

  function getOpenStatus() {
    proxy
      .$http({
        type: 'get',
        url: '/coupon/status',
      })
      .then((result) => {
        openStatus.value = result.data
      })
  }
  function getTypeStatus() {
    proxy
      .$http({
        type: 'get',
        url: '/coupon/types',
      })
      .then((result) => {
        typeOptions.value = result.data
      })
  }
  function getStatusStatus() {
    proxy
      .$http({
        type: 'get',
        url: '/userCoupon/getStatus',
      })
      .then((result) => {
        statusOptions.value = result.data
      })
  }

  onMounted(() => {
    getOpenStatus()
    getTypeStatus()
    getStatusStatus()
  })
  return { openStatus, typeOptions, statusOptions }
}
